module.exports = __webpack_public_path__ + "img/icon-new.792eefea.png";